import React, { useState } from 'react'

export interface Option {
  value: string
  label: string
}

interface Props {
  onChange: (val: string) => void
  value: string
  options: Option[]
  icon: JSX.Element
}

const SelectWithIcons = ({ onChange, options, value, icon }: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  const handleOptionClick = (val: string) => {
    setIsOpen(false)
    onChange(val)
  }
  return (
    <div className="border-white border rounded-md px-3 py-2 relative cursor-pointer">
      <div
        onClick={() => {
          setIsOpen((val) => !val)
        }}
        className="flex items-center">
        <div className="text-white w-7 h-7">{icon}</div>
        <div className="w-2" />
        <div className="text-white text-ellipsis overflow-hidden max-h-6">
          {options.find((item) => item.value === value)?.label}
        </div>
      </div>
      {isOpen && (
        <div className="absolute bg-white w-full left-0 top-[103%] rounded-m z-40">
          {options.map(({ label, value }) => (
            <div
              onClick={() => {
                handleOptionClick(value)
              }}
              key={value}
              className="border-b border-lightBorder px-2 py-2 hover:bg-coolGray hover:text-white text-ellipsis overflow-hidden">
              <div className="text-ellipsis max-h-6 overflow-hidden">{label}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default SelectWithIcons
